export default __webpack_public_path__ + "static/media/react-home.5f194549.svg";